import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import {Observable} from 'rxjs';
import {UserService} from "@core/shared/services/user.service";
import {User} from "@core/shared/models/user";
import {filter, map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class CommissionPaymentGuard {

    constructor(
        private _router: Router,
        private _userService: UserService
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        if(state.url.startsWith('/account/logout')){

            return true;
        }

        return this._userService.currentUser.pipe(filter(user => !!user), map(user => this._canActivate(user, route, state)));
    }

    public _canActivate(user: User, route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        if (!user) {

            return false;
        }

        if(!this._userService.hasOneOfThisRoles(user, ['ROLE_OFFER_CREATOR', 'ROLE_OFFER_DISTRIBUTOR']) || !user.society.isValidAccount){

            return true;
        }

        if(user.society.isValidCommissionPayment){

           return true;
        }

        if(state.url.startsWith('/account/commission/payment')){

            return true;
        }

        this._router.navigate(['/account/commission/payment']);

        return false;
    }
}
